import type { NotificationInboxItem } from '../types/notification.types';
import type { NotificationAlertContext } from '../types/notification-alert.types';
import { getNotificationTime } from './notification-group.util';

/** Suppresses wrong-account, stale, background and currently displayed-chat interruptions. */
export const shouldPresentMessageNotification = (
  item: NotificationInboxItem,
  context: NotificationAlertContext
): boolean => {
  const time = getNotificationTime(item);
  return (
    item.tenantId === context.tenantId &&
    item.userId === context.userId &&
    context.focused &&
    !item.readAt &&
    Number.isFinite(time) &&
    time >= context.visibleSince - 1000 &&
    time >= context.now - 60_000 &&
    time <= context.now + 5000 &&
    item.metadata?.funnelConversationId !== context.conversation?.conversationId
  );
};
